import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pr-2" }
const _hoisted_2 = { class: "w-[38rem] h-[40rem] self-center" }
const _hoisted_3 = { class: "text-v_dark_gray mt-4" }
const _hoisted_4 = { class: "font-[700] mt-2 w-full" }
const _hoisted_5 = {
  key: 0,
  class: "text-v_red text-center"
}
const _hoisted_6 = { class: "mt-10 flex justify-between items-center" }

import { ref, reactive, watch } from "vue"
import {
	ModalContainer,
	H1,
	H2,
	Input,
	ModalCloseButton,
	ModalButton,
	ModalContentContainer,
} from "../atoms"
import { getUsername, getCodRev } from "@/repositories/users"
import { Notification } from "@/utils/enum"


export default /*#__PURE__*/_defineComponent({
  __name: 'UserModal',
  emits: [
	"filter",
	"closeUserModal",
	"enableLoading",
	"emitError",
],
  setup(__props, { emit }) {

let showButton = ref(false)
let validationError = ref(false)



let user: any = reactive({
	name: "",
	resaleCode: "",
})

const getUserByName = async () => {
	emit("enableLoading", true)

	const res: any = await getUsername(user.name.trim())

	if (res.status == 200 && res.data.data.data.length > 0) {
		emit("filter", res.data.data.data)
		emit("closeUserModal", false)
	} else if (res?.data?.data?.data?.length == 0) {
		validationError.value = true
	} else if (res.response.status == 401) {
		emit(
			"emitError",
			true,
			Notification.TITLE_SESSION_EXPIRED,
			Notification.SUBTITLE_SESSION_EXPIRED
		)
	} else {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	emit("enableLoading", false)
}

const getResaleCode = async () => {
	emit("enableLoading", true)

	const res: any = await getCodRev(user.resaleCode.trim())

	if (res?.status == 200) {
		emit("filter", res.data.data.users)
		emit("closeUserModal", false)
	} else if (res?.status == 400) {
		validationError.value = true
	} else if (res?.response.status >= 500) {
		emit(
			"emitError",
			true,
			Notification.TITLE_ERROR,
			Notification.SUBTITLE_ERROR
		)
	}

	emit("enableLoading", false)
}

const fetchResale = async () => {
	if (user.name != "") {
		getUserByName()
	} else {
		getResaleCode()
	}
}

watch(user, () => {
	let validade = []
	validationError.value = false

	for (const key in user) {
		if (user[key] != "") {
			validade.push(key)
		}
	}

	if (validade.length >= 1) {
		showButton.value = true
	} else {
		showButton.value = false
	}
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createBlock(_unref(ModalContainer), null, {
    default: _withCtx(() => [
      _createVNode(_unref(ModalContentContainer), {
        h: "32rem",
        width: 15
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("button", {
              class: "px-2 py-2 float-right w-8 active:scale-90",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeUserModal', false)))
            }, [
              _createVNode(_component_v_icon, { icon: "mdi-close-thick" })
            ])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(H1), { class: "text-v_dark_blue" }, {
              default: _withCtx(() => [
                _createTextVNode("Usuário")
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Nome:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Input), {
                w: "38rem",
                modelValue: _unref(user).name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(user).name) = $event))
              }, null, 8, ["modelValue"]),
              _createVNode(_unref(H2), { class: "mt-4" }, {
                default: _withCtx(() => [
                  _createTextVNode("ou")
                ]),
                _: 1
              }),
              _createVNode(_unref(H2), { class: "text-left font-[700]" }, {
                default: _withCtx(() => [
                  _createTextVNode("Revenda:")
                ]),
                _: 1
              }),
              _createVNode(_unref(Input), {
                w: "38rem",
                class: "mt-2",
                modelValue: _unref(user).resaleCode,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(user).resaleCode) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_unref(validationError))
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, " Usuário não encontrado. Tente novamente! "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(ModalCloseButton), {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('closeUserModal', false))),
                class: "active:scale-90"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              }),
              _createVNode(_unref(ModalButton), {
                disabled: !_unref(showButton),
                class: "active:scale-90",
                enableButton: _unref(showButton),
                onClick: fetchResale
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Pesquisar ")
                ]),
                _: 1
              }, 8, ["disabled", "enableButton"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})